import React from 'react';
import { testimonials } from '../data/constants';
export function Testimonials() {
  return <section className="py-16 px-4 max-w-6xl mx-auto" data-id="element-338">
      <div className="grid md:grid-cols-3 gap-6" data-id="element-339">
        {testimonials.map((t, i) => <div key={i} className="bg-surface border border-zinc-800 p-6 rounded-2xl flex flex-col h-full" data-id="element-340">
            <div className="flex items-center gap-3 mb-4" data-id="element-341">
              <div className="w-12 h-12 rounded-full bg-zinc-800 flex items-center justify-center font-space-grotesk font-bold text-lg text-zinc-300" data-id="element-342">
                {t.initials}
              </div>
              <div data-id="element-343">
                <div className="font-bold text-white" data-id="element-344">{t.name}</div>
                <div className="text-xs text-zinc-400" data-id="element-345">
                  {t.location} · {t.role}
                </div>
              </div>
            </div>
            <div className="text-yellow-400 text-sm mb-3" data-id="element-346">⭐⭐⭐⭐⭐</div>
            <p className="text-zinc-300 italic flex-grow" data-id="element-347">"{t.text}"</p>
          </div>)}
      </div>
    </section>;
}